import { render, staticRenderFns } from "./AddConfiguration.vue?vue&type=template&id=4c740ded&"
import script from "./AddConfiguration.vue?vue&type=script&lang=ts&"
export * from "./AddConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports